module.exports = __webpack_public_path__ + "static/monikawork3-9b37aa5b4525dcb10466509d287506d5.jpg";